import React from "react";
import { ScrollArea, Table, createStyles, Text, Box } from "@mantine/core";
import { useState } from "react";
import { useSelector } from "react-redux";
import RecordNotFound from "../RecordNotFound";
import TableLoader from "../TableLoader";
import StaffAttendanceTableRow from "../StaffTableRow/StaffAttendanceTableRow";
import { useLocation } from "react-router-dom";
import CustomBillingPagination from "../Pagination/CustomBillingPagination";
import { getAllAttendenceStaff } from "../../services/staff";

const useStyles = createStyles((theme) => ({
  header: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    borderRadius: "16px",
    transition: "box-shadow 150ms ease",
    "& th": {
      backgroundColor: "#fff",
      color: "#000 !important",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
    },
  },

  scrolled: {
    boxShadow: theme.shadows.sm,
  },
  notFoundContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-evenly",
    height: "100vh",
    gap: "8rem",
  },
  notFoundText: {
    color: "#A8A8A8",
    fontFamily: "Inter",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
  },
}));

const StaffAttendanceTable = ({ staff, handleRowClick, loading,range,debouncedSearch }) => {
  const { classes, cx } = useStyles();
  const [scrolled, setScrolled] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  // const { loading, staff } = useSelector((state) => state.staff);
  const { addAttendanceStaffLoading, attendanceStaff } = useSelector(
    (state) => state?.staff
  );






  

  // useEffect(() => {
  //   getSingleattendenceStaff();
  // }, [currentPage]);


    // const attendenceStaff = async () => {
    //   try {
    //     setLoading(true);
    //     await getAllAttendenceStaff(currentPage, range, debouncedSearch);
    //   } catch (e) {
    //     console.log("🚀 ~ attendenceStaff ~ e:", e);
    //   } finally {
    //     setLoading(false);
    //   }
    // };


    

  const getSingleattendenceStaff=async(pageNumber)=>{
    try {

      // let payload={
      //   page:pageNumber,
      //   singleId:"67b56a9b54dc6ebb326b4aa4"
      // }

      // console.log('payload',payload);
      
      // setLoading(true);
      await getAllAttendenceStaff(pageNumber,range,debouncedSearch,staff);
      
    } catch (error) {
      console.log("🚀 ~ attendenceStaff ~ e:", error);
    }
  }

  const handlePageChange = async(pageNumber) => {
    setCurrentPage(pageNumber);
    await getSingleattendenceStaff(pageNumber)
  };

  const filteredStaff =
    staff === "all"
      ? attendanceStaff?.attendanceStaff
      : attendanceStaff?.attendanceStaff?.filter(
          (item) => item?.staff?.id === staff
        );

  // console.log('filteredStaff',filteredStaff);

  // console.log('attendanceStaff',attendanceStaff);
  const location = useLocation();

  // const rows = <tr></tr>;
  const rows = filteredStaff?.map((row, index) => {
    return (
      <StaffAttendanceTableRow
        row={row?.staff}
        index={index}
        track={row}
        handleRowClick={handleRowClick}
        currentPage={currentPage}
        range={range}
      />
    );
  });

  return (
    <ScrollArea
      onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
      sx={{ fontFamily: "Inter", backgroundColor: "#fff" }}
    >
      <Table
        withBorder
        fontSize={"sm"}
        highlightOnHover
        enablestickyheader
        verticalSpacing={"md"}
        style={{ borderRadius: "16px", border: "1px solid #E5E5E5" }}
      >
        <thead className={cx(classes.header, { [classes.scrolled]: scrolled })}>
          <tr>
            <th style={{ minWidth: "100px" }}>First Name</th>
            <th style={{ minWidth: "100px" }}>Last Name</th>
            <th style={{ minWidth: "100px" }}>Facility</th>
            <th style={{ minWidth: "100px" }}>Client</th>
            <th style={{ minWidth: "100px" }}>Date</th>
            <th style={{ minWidth: "120px" }}>Clock-in Time</th>
            <th style={{ minWidth: "120px" }}>Clock-out Time</th>
            <th style={{ minWidth: "100px" }}>Break Time</th>
            <th style={{ minWidth: "130px" }}>Hours Worked</th>
            <th style={{ minWidth: "100px" }}>Status</th>
            <th style={{ minWidth: "100px" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={1000}>
                <TableLoader />
              </td>
            </tr>
          ) : rows?.length ? (
            rows
          ) : (
            <tr>
              <td colSpan={1000}>
                <Box className={classes.notFoundContainer}>
                  <RecordNotFound />
                  <Text className={classes.notFoundText}>No records found</Text>
                </Box>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      {location.pathname !== "/home/staff/manage-attendance/all" && (
        <CustomBillingPagination
          data={filteredStaff?.length}
          itemsPerPage={10}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
        />
      )}
    </ScrollArea>
  );
};

export default StaffAttendanceTable;
